

import React, { useEffect, useState } from 'react';

import ic_add_account from "assets/images/ic_add_account.svg";
import ic_edit from "assets/images/ic_edit.svg";
import ic_delete_invoices from "assets/images/ic_delete_invoices.svg";
import ic_export from "assets/images/ic_export.svg";
import ic_generate_invoice from 'assets/images/ic_generate_invoice.svg';
import ic_clone_account from "assets/images/ic_clone_account.svg";
import ic_upload_file from "assets/images/ic_upload_file.svg";
import ic_automate from "assets/images/ic_automate.svg";
import ic_deactivate_account from "assets/images/ic_deactivate_account.svg";
import ic_quici_product_setup from "assets/images/ic_quici_product_setup.svg";

import AccountUpdate from "./accountUpdate/AccountUpdate";
import MultiAccountUpdate from './multiAccountUpdate/MultiAccountUpdate';
import { 
	DashboardLayout, Dropdown, GeneralTable, FormCheckbox, AlertMessage, Toaster,
    Button, SubmenuTooltip, MoreButton, ConfirmationModal, Datepicker,
} from "components";

import { func_validation, func_datetime, func_url, isStringEqual_caseInsensitive, isObjectEmpty, isNumberOrStringValid, isArrayNotEmpty, isObjectNotEmpty, getArrayLength, isArrayEmpty } from 'functions';
import useRecursiveBillingSetupColumns from './useRecursiveBillingSetupColumns';

import 'assets/scss/billingPortal/modules/recursiveBillingSetup/recursiveBillingSetup.scss';
import { useAlertMessage, useDropdownList, useTableActions } from './hooks';
import { useTableData } from './hooks/useTableData';
import { useRemarksModal } from './hooks/tableActions/useRemarksModal';
import { MultiFilters } from 'components/filters/MultiFilters';
import QuickSetup from './quickSetup/QuickSetup';
import { chargeMethodList, subsidiaryList } from 'constants/lists';
import { useCustomSelector } from 'hooks';



export default function RecursiveBillingSetupPresentation(props) {    
    const { 
        isAccountRecordUpdatedSuccessfully,
        getBillingSetup_requesting,
        getUnbillBillingSetup_requesting,
        addAccount_requesting, updateAccount_requesting,
        addAccount_errorMsg, updateAccount_errorMsg,

        history
    } = props;


    // States

    const [isDataUnbill, setIsDataUnbill] = useState(false);
    
    const [selectedRowIdx_notClickable, setSelectedRowIdx_notClickable] = useState();
    const [selectedBillingSetup, setSelectedBillingSetup] = useState([]);

    const [billingSetupId, setBillingSetupId] = useState("");
    const [billingSetupDetailsId, setBillingSetupDetailsId] = useState("");
    const [billingSetupDiscountId, setBillingSetupDiscountId] = useState("");

    const [currentTabId, setCurrentTabId] = useState("active");
    const [isFilterReset, setIsFilterReset] = useState();

    const [isQuickSetupVisible, setIsQuickSetupVisible] = useState();
    const [isTableRefreshRequired, setIsTableRefreshRequired] = useState();

    // to differentiate between add multi or single account
    const [isAddMultiAccount, setIsAddMultiAccount] = useState(false);

    const { addAccount_isSuccessful } = useCustomSelector("recursiveBillingSetup");

    useEffect(() => {
        if (isFilterReset) setIsFilterReset(false);
    }, [isFilterReset]);

    useEffect(() => {
        if (isAccountRecordUpdatedSuccessfully) {
            setIsTableRefreshRequired(true);
        }
    }, [isAccountRecordUpdatedSuccessfully]);
    useEffect(() => {
        if (addAccount_isSuccessful) {
            setIsTableRefreshRequired(true);
        }
    }, [addAccount_isSuccessful]);
    useEffect(() => {
        if (isTableRefreshRequired) setIsTableRefreshRequired(false);
    }, [isTableRefreshRequired])

    const {
        comIdList,
        accountCodeList,
        productCodeList,
        nextBilledDateList,
        dealerCodeList,
        salesPersonCodeList,
        productNameList,

        setSelectedComId,
        setSelectedAccountCode,
        setSelectedProductCode,
        setSelectedNextBilledDate
    } = useDropdownList(props);

    // Table data
    const {
        masterSet,
        tableData,
        totalRecords
    } = useTableData(props);

    // Remarks
    const {
        setAccountCode, setIsModalVisible_remarks,
        remarksModal
    } = useRemarksModal(props);

    // First Row
    let { 
        getFirstRowColumns,
        isAddAccountDisplayVisible, setAddAccountDisplayVisibility
    } = useRecursiveBillingSetupColumns({ 
        addAccount_requesting: addAccount_requesting,
        addAccount: props.addAccount,
        isAddingAccountFunction: true,
        isActionSuccessful: isAccountRecordUpdatedSuccessfully
    });

    // Columns
    let { 
        getColumns,
        getColumns_action
    } = useRecursiveBillingSetupColumns({        
        deleteAccount: props.deleteAccount,
        updateAccount_requesting: updateAccount_requesting,
        updateAccount: props.updateAccount,
        isUpdateAccountFunction: true,
        handleRowClickability: handleRowClickability,
        isActionSuccessful: isAccountRecordUpdatedSuccessfully,
        setAccountCode, setIsModalVisible_remarks,
        getRemarks: props.getRemarks
    });
    function handleRowClickability(rowIdx) {
        setSelectedRowIdx_notClickable(rowIdx);
    }

    // Table Actions
    const {
        isFormVisible, setIsFormVisible,

        handleAccount_edit,
        isEditingAccount, setIsEditingAccount,

        validateOnDelete,
        deleteAccountModal,

        validateOnDeactivate,
        deactivateAccountModal,

        handleCloneAccount,

        validateOnInvoiceGeneration,
        generateInvoiceModal,

        setIsModalVisible_billingUpload,
        billingUploadModal,

        setIsModalVisible_accountAutomation,
        accountAutomationModal
    } = useTableActions({
        ...props,
        selectedBillingSetup, setSelectedBillingSetup,
        setBillingSetupId, setBillingSetupDetailsId, setBillingSetupDiscountId,
    });

    // Error Messages
    const [alertMsgDisplay] = useAlertMessage({
        ...props,
        isFormVisible
    });

    // Reset
    useEffect(() => {
        if (!isFormVisible) setSelectedBillingSetup([]);
    }, [isFormVisible]);

    let isActiveTab = (currentTabId === "active");

    return (
        <div className={"recursiveBillingSetup"}>
            {/* Delete Alert */}
            {deleteAccountModal}

            {/* Deactivation Alert */}
            {deactivateAccountModal}
            
            {/* Invoice Generation Alert */}
            {generateInvoiceModal}

            {/* Upload Billing Setup */}
            {billingUploadModal}

            {/* Automation */}
            {accountAutomationModal}

            {/* Remarks */}
            {remarksModal}

            <div className={isFormVisible || isQuickSetupVisible? "d-none":""}>
                <DashboardLayout 
                    headerTitle={"Recursive Billing Setup"}

                    bodyClassName={"recursiveBillingSetup-body"}
                    body={(
                        <GeneralTable
                            className={"recursiveBillingSetup-body-table"}
                            columns={getColumns()}
                            data={tableData}
                            minRows={10}

                            outerTableHeader={(outerTableHeader_props) => {
                                const { 
                                    selectedRows: selectedAccounts,
                                    filterOptions, setFilterOptions
                                } = outerTableHeader_props;

                                return (
                                    <React.Fragment>
                                        {/* Alert Error Messages */}
                                        {alertMsgDisplay}

                                        {/* Table Header */}
                                        <div className={"recursiveBillingSetup-body-header d-flex align-items-center justify-content-between "}>
                                            <div className={"recursiveBillingSetup-bodyHeader-title tableHeaderTitle"}>
                                                Account List
                                            </div>

                                            <div className={"recursiveBillingSetup-bodyHeader-action d-flex align-items-center"}>
                                                {/* <div className={"recursiveBillingSetup-bodyHeaderAction-setMaster"}>
                                                    <FormCheckbox 
                                                        isCheckboxCheckedDefault={masterSet}
                                                        checkboxClassName={"recursiveBillingSetup-setMasterHeader-checkbox"}
                                                        checkboxIconClassName={"recursiveBillingSetup-setMasterHeader-checkboxIcon"}
                                                        labelClassName={"recursiveBillingSetup-setMaster-label"}
                                                        checkboxLabel={"Set Master"}
                                                        isCheckboxIconVisible
                                                        isCheckboxDisabled
                                                    />
                                                </div> */}

                                                <div className={"recursiveBillingSetup-tableHeaderAction-addAccountWrapper"}>  
                                                    <Button
                                                        className={"recursiveBillingSetup-tableHeaderAction-addAccount tableHeaderButtonPadding d-flex align-items-center " +
                                                            (func_validation.isUserAccessDenied(props, "Internal_BillingSetup_Add")? "recursiveBillingSetup-tableHeaderAction-addAccount_disabled ":"")}
                                                        // handleOnClick={() => { setAddAccountDisplayVisibility(true); }} // To trigger adding account in the first table row
                                                        handleOnClick={() => {
                                                            if (func_validation.isUserAccessGranted(props, "Internal_BillingSetup_Add")) {
                                                                setIsFormVisible(true);
                                                                setIsEditingAccount(false);
                                                                setBillingSetupId("");
                                                                setBillingSetupDetailsId("");
                                                                setBillingSetupDiscountId("");
                                                                setIsAddMultiAccount(false)
                                                            }
                                                        }}

                                                        isDecoration_primaryTransparent
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"recursiveBillingSetup-headerAddAccount-icon "}
                                                                src={ic_add_account}
                                                                alt={"Add Icon"}
                                                            />
                                                            <div className={"recursiveBillingSetup-headerAddAccount-label"}>
                                                                Add Account
                                                            </div>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>

                                                <SubmenuTooltip
                                                    buttonClassName={"recursiveBillingSetup-tableHeaderAction-moreActionsWrapper"}
                                                    menuItems={
                                                        [
                                                            ...isActiveTab? [{
                                                                icon: ic_edit,
                                                                label: "Edit Account",
                                                                onClick: () => { handleAccount_edit(selectedAccounts); },
                                                            }]:[],
                                                            {
                                                                icon: ic_delete_invoices,
                                                                label: "Delete Account",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_BillingSetup_Delete"),
                                                                onClick: () => { validateOnDelete(selectedAccounts); },
                                                            },
                                                            ...isActiveTab? [{
                                                                icon: ic_deactivate_account,
                                                                label: "Deactivate Account",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_BillingSetup_Delete"),
                                                                onClick: () => { validateOnDeactivate(selectedAccounts); },
                                                            }]:[],
                                                            {
                                                                icon: ic_clone_account,
                                                                label: "Clone Account",
                                                                onClick: () => { handleCloneAccount(selectedAccounts); },
                                                            },
                                                            ...isActiveTab? [{
                                                                icon: ic_generate_invoice,
                                                                label: "Generate Invoice",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_ProformaInvoice_Generate"),
                                                                onClick: () => { validateOnInvoiceGeneration(selectedAccounts); },
                                                            }]:[],
                                                            ...isActiveTab? [{
                                                                icon: ic_upload_file,
                                                                label: "Upload File",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_BillingSetup_AddAll"),
                                                                onClick: () => { setIsModalVisible_billingUpload(true); },
                                                            }]:[],
                                                            {
                                                                icon: ic_automate,
                                                                label: "Automate",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_AutomateList_View"),
                                                                onClick: () => { setIsModalVisible_accountAutomation(true); },
                                                            },
                                                            {
                                                                icon: ic_quici_product_setup,
                                                                label: "Quick Product Setup",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_BillingSetup_Add"),
                                                                onClick: () => { 
                                                                    if (getArrayLength(selectedAccounts) > 1) {
                                                                        Toaster({
                                                                            type: "info",
                                                                            msg: "Please select only 1 row"
                                                                        });
                                                                    }
                                                                    else if (isArrayEmpty(selectedAccounts)) {
                                                                        Toaster({
                                                                            type: "info",
                                                                            msg: "Please select 1 row"
                                                                        })
                                                                    }
                                                                    else if (selectedAccounts[0]?.ChargeMethod != "License") {
                                                                        Toaster({
                                                                            type: "info",
                                                                            msg: "Selected row must have 'License' charge method"
                                                                        });
                                                                    }
                                                                    else  {
                                                                        setIsQuickSetupVisible(true); 
                                                                        setSelectedBillingSetup(selectedAccounts)
                                                                    }
                                                                },
                                                            },
                                                            {
                                                                icon: ic_add_account,
                                                                label: "Add Multi Account",
                                                                isDisabled: !func_validation.isUserAccessGranted(props, "Internal_BillingSetup_Add"),
                                                                onClick: () => { 
                                                                    setIsFormVisible(true);
                                                                    setIsEditingAccount(false);
                                                                    setBillingSetupId("");
                                                                    setBillingSetupDetailsId("");
                                                                    setBillingSetupDiscountId("");
                                                                    setIsAddMultiAccount(true)
                                                                },
                                                            },
                                                            // {
                                                            //     icon: ic_export,
                                                            //     label: "Export",
                                                            //     onClick: exportAllBillingSetup,
                                                            // },
                                                            // NOTE: There is a permission for deleting all billing setups, but it is curently not used in UI.
                                                            //       "Internal_BillingSetup_DeleteAll"
                                                        ]
                                                    }
                                                >
                                                    <MoreButton
                                                        iconClassName={"recursiveBillingSetup-moreActionsWrapper-icon"}
                                                    />
                                                </SubmenuTooltip>
                                            </div>
                                        </div>

                                        
                                        {/* Table Filters */}
                                        <div className={"d-flex flex-wrap align-items-center"}>
                                            <MultiFilters
                                                defaultFilterOption={{
                                                    label: "Company ID", 
                                                    propertyName: "comId",
                                                    placeholder: "Company ID",
                                                    suggestionList: [{ label: "All", value: "All" }].concat(comIdList),
                                                    inputType: "search",
                                                    isInputDigitOnly: true
                                                }}
                                                filterOptions={[
                                                    {
                                                        label: "Company ID", 
                                                        propertyName: "comId",
                                                        placeholder: "Company ID",
                                                        suggestionList: [{ label: "All", value: "" }].concat(comIdList),
                                                        inputType: "search",
                                                        isInputDigitOnly: true
                                                    },
                                                    {
                                                        label: "Account Code", 
                                                        propertyName: "accountCode",
                                                        placeholder: "Account Code",
                                                        suggestionList: [{ label: "All", value: "" }].concat(accountCodeList),
                                                        inputType: "search"
                                                    },
                                                    {
                                                        label: "Product Code", 
                                                        propertyName: "productCode",
                                                        placeholder: "Product Code",
                                                        suggestionList: [{ label: "All", value: "" }].concat(productCodeList),
                                                        inputType: "search"
                                                    },
                                                    {
                                                        label: "Next Billed Date", 
                                                        propertyName: "nextBilledDate",
                                                        placeholder: "Next Billed Date",
                                                        options: [{ label: "All", value: "" }].concat(nextBilledDateList),
                                                        inputType: "dropdown"
                                                    },
                                                    {
                                                        label: "Charge Method", 
                                                        propertyName: "chargeMethod",
                                                        placeholder: "Charge Method",
                                                        options: [{ label: "All", value: "" }].concat(chargeMethodList),
                                                        inputType: "dropdown"
                                                    },
                                                    {
                                                        label: "Subsidiary", 
                                                        propertyName: "subsidiary",
                                                        placeholder: "Subsidiary",
                                                        options: [{ label: "All", value: "" }].concat(subsidiaryList),
                                                        inputType: "dropdown"
                                                    },
                                                    {
                                                        label: "SO Number Ref", 
                                                        propertyName: "soRef",
                                                        placeholder: "SO Number Ref",
                                                        suggestionList: [{ label: "All", value: "" }],
                                                        inputType: "search",
                                                        isInputDigitOnly: true
                                                    },
                                                    {
                                                        label: "Draft Status",
                                                        propertyName: "isDraft",
                                                        placeholder: "Draft Status",
                                                        options: [
                                                            { label: "Draft", value: "Draft" },
                                                            { label: "Not Draft", value: "Not Draft" },
                                                        ],
                                                        inputType: "dropdown",
                                                    }
                                                ]}
                                                dropdownPlaceholder={"Select Filter"}
                                                
                                                onApplyFilter={(inputFilters) => {
                                                    if (func_validation.isNotNullUndefined(inputFilters?.isDraft)) {
                                                        inputFilters = {
                                                            ...inputFilters,
                                                            isDraft: (inputFilters?.isDraft === "Draft"),
                                                        };
                                                    }

                                                    setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});

                                                    let comId = inputFilters?.comId;
                                                    let accountCode = inputFilters?.accountCode;
                                                    let productCode = inputFilters?.productCode;
                                                    let nextBilledDate = inputFilters?.nextBilledDate;

                                                    setSelectedComId(comId);
                                                    setSelectedAccountCode(accountCode);
                                                    setSelectedProductCode(productCode);

                                                    if (nextBilledDate) {
                                                        setSelectedNextBilledDate(nextBilledDate);
                                                        setIsDataUnbill(isStringEqual_caseInsensitive(nextBilledDate, "Till today"))
                                                    }
                                                    else setIsDataUnbill(false);
                                                }}

                                                isResetFromParentRequired={isFilterReset}
                                            />
                                        </div>
                                    </React.Fragment>
                                );
                            }}

                            tabsDetails={[
                                {
                                    id: "active",
                                    text: "Active",
                                    filters: {
                                        inactive: false
                                    }
                                },
                                {
                                    id: "inactive",
                                    text: "Inactive",
                                    filters: {
                                        inactive: true
                                    }
                                }
                            ]}
                            onTabIdChange={(tabId) => {
                                setIsFilterReset(true);
                                setCurrentTabId(tabId);
                            }}
                            defaultTabId={currentTabId}
                            defaultFilter={{
                                inactive: false,
                                isDraft: false
                            }}
                            isTabRequired

                            isTableRefreshRequired={isTableRefreshRequired}

                            getTableData={isDataUnbill? props.getUnbillBillingSetup: props.getBillingSetup}

                            isExpanderRequired isRowExpanderColumnFirst

                            isTableDataLoading={getBillingSetup_requesting || getUnbillBillingSetup_requesting}

                            isUsingPagination
                            totalRecords={totalRecords}

                            isColumnResizeable 
                            isTableOddRowsDarken 
                            
                            isCheckboxRequired isCheckboxColumnFirst

                            // NOTE: this was used to prevent user from deleting 2 of the same account code because back then
                            //       when an account code is deleted, then all other setups that has same account code as 
                            //       deleted account code will also be deleted
                            // onCheckboxDisabledValidationList={(row, selectedIndexes, data) => {
                            //     // Get current row's accoutn code
                            //     let current_accountCode = row?.original?.AccountCode;

                            //     if (isArrayNotEmpty(data)) {
                            //         let disabledList = data.map((details, idx) => {
                            //             if (!selectedIndexes[idx]) {
                            //                 // Find any matched account code
                            //                 for (let index in selectedIndexes) {
                            //                     if (selectedIndexes.hasOwnProperty(index) &&
                            //                         isNumberOrStringValid(index)) {
                                                    
                            //                         let index_formatted = parseInt(index);
                            //                         let selectedAccountCode = data[index_formatted]?.AccountCode;
                            //                         if (selectedAccountCode === current_accountCode) {
                            //                             return true;
                            //                         }
                            //                     }
                            //                 }
                                            
                            //             }

                            //             return false;
                            //         });

                            //         return disabledList;
                            //     }

                            //     return [];
                            // }}

                            // NOTE: Below are commented code that REQUIRES refactoring and fix.
                            //       It is there to tell you that this table previously handles adding
                            //       and editting data within the table iteself.

                            // selectedRowIdx_notClickable={selectedRowIdx_notClickable}

                            // tablePreBody={getFirstRowColumns()}
                            // isTablePreBodyVisible={isAddAccountDisplayVisible}

                            // actionColumnWrapperClassName={"d-flex align-items-center"}
                            // actionColumnDisplayFunc={(rowIdx, handleSelectedRow) => {
                            //     let masterSet = func_validation.getObjectPropertyValue(tableData[rowIdx], "masterSet");
                            //     let companyId = func_validation.getObjectPropertyValue(tableData[rowIdx], "CompanyId");
                            //     let accountCode = func_validation.getObjectPropertyValue(tableData[rowIdx], "AccountCode");
                            //     let billingSetupId = func_validation.getObjectPropertyValue(tableData[rowIdx], "Id");
                            //     let billingSetupDetails = func_validation.getObjectPropertyValue(tableData[rowIdx], "BillingSetupDetails");
                            //     let billingSetupDetailsId = 0;
                            //     if (func_validation.isArrayNotEmpty(billingSetupDetails)) {
                            //         billingSetupDetailsId = func_validation.getObjectPropertyValue(billingSetupDetails[0], "Id");
                            //     }
                            //     let isMasterSet = func_validation.isStringTrimNotEmpty(masterSet);
                                
                            //     let initColumn = getColumns_action({
                            //         companyId: companyId,
                            //         accountCode: accountCode, 
                            //         billingSetupId: billingSetupId,
                            //         billingSetupDetailsId: billingSetupDetailsId,
                            //         isMasterSet: isMasterSet,
                            //         setMaster: props.setMaster,
                            //         handleSelectedRow: handleSelectedRow,
                            //         deleteAccount_requesting: deleteAccount_requesting,
                            //         updateAccount_requesting: updateAccount_requesting
                            //     });

                            //     let columnDisplay = func_validation.getObjectPropertyValue(initColumn, "Cell");
                            //     return columnDisplay(rowIdx);
                            // }}
                            // isActionColumnRequired
                        />
                    )}
                />
            </div>

            {/* Single Form */}
            {isFormVisible && !isAddMultiAccount && (
                <AccountUpdate 
                    {...props}
                    isEditing={isEditingAccount}
                    history={history}

                    billingSetupDetailsId={billingSetupDetailsId} 
                    billingSetupId={billingSetupId}
                    billingSetupDiscountId={billingSetupDiscountId}

                    billingSetup={selectedBillingSetup[0]}

                    comIdList={comIdList}
                    accountCodeList={accountCodeList}
                    dealerCodeList={dealerCodeList}
                    salesPersonCodeList={salesPersonCodeList}

                    productCodeList={productCodeList}
                    productNameList={productNameList}

                    updateParentState_visiblity={setIsFormVisible}

                    addAccount={props.addAccount}
                    updateAccount={props.updateAccount}

                    isAccountRecordUpdatedSuccessfully={isAccountRecordUpdatedSuccessfully}
                    isAccountRecordUpdateRequesting={props.isAccountRecordUpdateRequesting}

                    addAccount_errorMsg={addAccount_errorMsg}
                    updateAccount_errorMsg={updateAccount_errorMsg}
                />
            )}

            {/* Multi Form */}
            {isFormVisible && isAddMultiAccount && (
                <MultiAccountUpdate 
                    {...props}
                    isEditing={isEditingAccount}
                    history={history}

                    billingSetupDetailsId={billingSetupDetailsId} 
                    billingSetupId={billingSetupId}
                    billingSetupDiscountId={billingSetupDiscountId}

                    billingSetup={selectedBillingSetup[0]}

                    comIdList={comIdList}
                    accountCodeList={accountCodeList}
                    dealerCodeList={dealerCodeList}
                    salesPersonCodeList={salesPersonCodeList}

                    productCodeList={productCodeList}
                    productNameList={productNameList}

                    updateParentState_visiblity={setIsFormVisible}

                    addAccount={props.addAccount}
                    updateAccount={props.updateAccount}

                    isAccountRecordUpdatedSuccessfully={isAccountRecordUpdatedSuccessfully}
                    isAccountRecordUpdateRequesting={props.isAccountRecordUpdateRequesting}

                    addAccount_errorMsg={addAccount_errorMsg}
                    updateAccount_errorMsg={updateAccount_errorMsg}
                />
            )}

            {isQuickSetupVisible && (
                <QuickSetup
                    setupInfo={selectedBillingSetup[0]}
                    updateParentState_visiblity={setIsQuickSetupVisible}
                />
            )}
        </div>
    );
}